export const tagsTypes = {
  GET_USER_PROFILE: "GET_USER_PROFILE",
  GET_PRODUCT_DETAIL: "GET_PRODUCT_DETAIL",
  GET_PRODUCT_LIST: "GET_PRODUCT_LIST",
  GET_FINANCE_LISTING: "GET_FINANCE_LISTING",
  GET_BOOKING_ITEM_DETAILS: "GET_BOOKING_ITEM_DETAILS",
  GET_TRANSACTIONS_LISTING: "GET_TRANSACTIONS_LISTING",
  GET_SPECIAL_OFFERS_LIST: "GET_SPECIAL_OFFERS_LIST",
  GET_DASHBOARD_CONTENT: "GET_DASHBOARD_CONTENT",
};
